import  { GridView, LocalDataProvider } from "realgrid";
import $ from "jquery";
import { MESSAGE, MSG, MsgBox } from "./cpmMESSAGE";
import { menuIdList } from "Layouts/LayoutMenuData";

/**
 * gridView를 담고 있는 전역변수
 * @type {{}}
 */
export  var rg2GridView = {};

/**
 * dataProvider를 담고 있는 전역변수
 * @type {{}}
 */
export   var rg2DataProvider = {};

/**
 *초기 컬럼 정보를 담고 있는 전역변수
 * @type {{}}
 */
export   var rg2Columns = {};


/*초기 Layout */
export   var rg2Layouts = {};

/**
 *숨긴 컬럼
 * @type {{}}
 */
export   var rg2HiddenColumns = {};

/**
 * Enum for rg2RowState  values.
 * @ enum {string}
 */
export   var rg2RowState = {
      CD :"createAndDeleted"   /*생성 후 삭제됨*/
    , C : "created"            /* 생성됨*/
    , D : "deleted"            /*    삭제됨*/
    , U : "updated"            /*업데이트됨*/
    , M : "modified"           /* 수정된 전체 , C, D, U*/
    , N : "none"               /* 아무것도 아님 */
    , A : "all"                /* 전체 */

    ,   properties: {
        createAndDeleted:  "CD"
       ,created: {name: "C", value: "created", msg : "입력된"}
       ,deleted: {name: "D", value: "deleted", msg : "삭제된"}
       ,updated: {name: "U", value: "updated", msg : "수정된"}
       ,modified: {name: "M", value: "modified", msg : "변경된"}
       ,none: {name: "N", value: "none", msg : ""}
       ,all : {name: "A", value: "all", msg : "전체"}
    }
}

export  var  rg2RowGetOpt = {
    nullText: '',
    datetimeFormat: "yyyyMMdd"
}

/**
 * @class
 */
export var rg2Comm = {

    /**
     * 리얼그리드 2.0 객체 여부
     *
     * @param {string | GridView } poGridId  : 확인할 RealGrid 객체 아이디
     * @returns {boolean} : 객체여부
     */
    checkRealGrid : function (poGridId) {
        var rtn = false;
        var vaKey = Object.keys(rg2GridView);
        var vnCnt = vaKey.length;
        if (vnCnt === 0) {
            return false;
        }
        if (poGridId !== undefined) {
            var _rg2Id = "";
            if (typeof poGridId === "string") {
                _rg2Id = poGridId;
            } else {
                _rg2Id = poGridId.getID();
            }
            for (var i = 0; i < vnCnt; i++) {
                if (_rg2Id === vaKey[i]) {
                    rtn = true;
                    break;
                }
            }
        } else {
            rtn = true;
        }
        return rtn;
    },
    /**
     * getGridView gridView 오브젝트 리턴
     *
     * @param  {string | GridView} poGridId : realgrid가 들어가는 div의 id
     * @returns {RealGrid} : gridView object
     */
    getGridView: function (poGridId) {
        if (typeof poGridId === "string") {
            return rg2GridView[poGridId];
        } else {
            return poGridId ;
        }
    }
    ,

    /**
     * getDataProvider gridView 오브젝트 리턴
     *
     * @param {string | GridView } poGridId  realgrid가 들어가는 div의 id
     * @returns {dataProvider } : dataProvider object
     */
    getDataProvider: function (poGridId) {
        if (typeof poGridId === "string") {
            return rg2DataProvider[poGridId];
        } else {
            return poGridId.getDataSource() ;
        }

    }
    ,

    /**
     * gridView 오브젝트 id
     *
     * @param  {string | GridView }  poGridId :  realgrid가 들어가는 div의 id
     * @returns {GridView} : realgrid  object
     */
    getGridId: function (poGridId) {
        if (typeof poGridId === "string") {
            return poGridId ;
        } else {
            return poGridId.getContainer().id  ;
        }
    }
    ,


    /**
     * editing 상태의 그리드를 커밋한다
     *
     * @param  {string | GridView }  poGridId :  realgrid가 들어가는 div의 id,없으면 모든 그리드를 커밋
     */
    gridCommit: function (poGridId) {
        try{
            if ((poGridId ?? "") === "" ) {
                var vaKey = Object.keys(rg2GridView);
                var vnCnt = vaKey.length;

                for (var i = 0; i < vnCnt; i++) {
                    var vsGridId = vaKey[i];
                    this.getGridView(vsGridId).commit();
                }
            } else {
                this.getGridView(poGridId).commit();
            }
        }catch (e) {
            //console.log(e)  ;
        }

    }
    ,


    /**
     * grdView초기화
     *
     * @param  {string }  poGridId : realgrid가 들어가는 div의 id
     * @param  {{}} poOption : 초기화 옵션 json object     *
     *<pre>
     *        checkFlag : 체크Bar 표시여부 (defualt :false)
     *        stateFlag : 상태Bar 표시여부 (defualt :false)
     *        recNoFlag : 인디케이터  표시여부  (defualt :true )
     *        groupingFlag : 그룹핑 여부(default : true )
     *        filterFlag : 필터여부 (default : true )
     *        autoFit :너비에 맞춰 컬럼 너비를 조정(default : even, evenFill||fill||non )
     *        footerFlag : footer표시 여부  (default : true )
     *        sortFlag : 정렬 (default : true )
     *        pasteOptions : 붙여넣기 가능여부 (default : false)
     *        filterAreaFlag : 필터정보 표시 여부 (defualt _: true, filterFlag :false 일 경우 false )
     *        saveColumnFlag :컬럼저장 가능 여부 (default : true )
     *        columns :gridView 컬럼정보 Array
     *        contextMenuFlag :  contextMenu 여부  (default : true)
     *        wqFlag : 웹스퀘어 사용 여부 (default : true )
     *        scrnPgmId : 화면아이디
     *        menuId : 메뉴아이디
     *        softDeleting : 행 수정, 삭제 상태 변경 여부 (default : false)
     *        hideDeletedRows : 삭제 상태 행 표시 여부 (default : false)
     *        buttonFlag : 공통버튼 표시여부 (default : true)
     * </pre>
     * @returns {GridView} : gridView Object
     */
    setGridInit: function (poGridId, poOption) {
        try {
 

            // 주석
            //리얼그리드가 있는 경우에는
            // if (this.checkRealGrid(poGridId)) {
            //     return;
            // }
            const voDataProvider = new LocalDataProvider();
            const voGridView = new GridView(poGridId);
            voGridView.setDataSource(voDataProvider);

            voGridView.setDisplayOptions({
                showEmptyMessage: true  ,
                emptyMessage :"조회 결과가 없습니다."
            });

            /*화면아이디*/
            const pathname = window.location.pathname.split('/').slice(-1)[0] || '';
            voGridView.scrnPgmId = (poOption.scrnPgmId ?? pathname )  ;
            /* 메뉴아이디 */
            voGridView.menuId  = (poOption.menuId ? poOption.menuId : menuIdList[voGridView.scrnPgmId] ?? ""  )  ;
            /* 아이디 */
            voGridView.id  = (poGridId ?? ""  )  ;

            // softDeleting
            voDataProvider.softDeleting = (poOption.softDeleting ??  false )
            
            // hideDeletedRows
            voGridView.hideDeletedRows = (poOption.hideDeletedRows ??  false )

            //CheckBar
            voGridView.setCheckBar({
                visible:  (poOption.checkFlag ??  false )
            });

            // state bar
            voGridView.setStateBar({
                visible: (poOption.stateFlag ?? false)
            });
            // 행번호(인디케이터)
            voGridView.setRowIndicator({
                visible: (poOption.recNoFlag ?? true)
            });

            // rowGroup 활성화 여부
            var vsGroupingFlag = (poOption.groupingFlag?? true );
            voGridView.setGroupPanel({
                visible: vsGroupingFlag  ,
                height : 77
            });
            voGridView.setGroupingOptions({
                enabled: vsGroupingFlag,
                expandWhenGrouping: true
            });
            voGridView.setRowGroup(
                {
                    visible: vsGroupingFlag,
                    collapsedAdornments: "both", //그룹핑시에 그룹 접었을때 풋터 보이기
                    mergeMode: false,
                    headerStatement: '${groupField}: ${groupValue} - ${rowCount} rows'
                }
            );
            voGridView.groupPanel.height ="55px" ;


            //필터
            var vsFilterFlag = (poOption.filterFlag ?? true );
            if (vsFilterFlag === false) {
                voGridView.setFilteringOptions({
                    enabled: false,
                    handleVisibility: "hidden"
                });
            } else {
                voGridView.setFilteringOptions({
                    enabled: true,
                    handleVisibility: "hovered",
                    clearWhenSearchCheck: true,
                    selector: {
                        maxWidth: 300,
                        closeWhenClick: false,
                        textToTitle : true,
                        searchIgnoreCase : true
                    },
                    automating: {
                        lookupDisplay: true,
                        numberCategorize: true
                    }
                })
            }

            voGridView.setFilteringOptions({handleVisibility: "hovered"});
            voGridView.filteringOptions.automating.filteredDataOnly = true

            //그리드 autoFit : 기본 even
            var vsAutoFit = poOption.autoFit || "even";
           if(poOption.autoFit ===  false || poOption.autoFit === "false" ){
                vsAutoFit = "none"  ;
            }
            voGridView.setDisplayOptions({
                fitStyle: vsAutoFit
            });

            //풋터 표시
            voGridView.setFooters({
                visible:  (poOption.footerFlag ?? true )
            });

            //Sort 여부
            voGridView.setSortingOptions({
                 enabled: (poOption.sortFlag ?? true )
                ,style:"exclusive"
            });
            voGridView.setOptions({
                sortMode : "explicit"
            });

            //붙여넣기 불가
            if (poOption.pasteOptions === true) {
                voGridView.setPasteOptions({
                    enabled: true,
                    selectionBase: false,
                    fillFieldDefaults: true,
                    fillColumnDefaults: true,
                    numberChars: ","
                });
            } else {
                voGridView.setPasteOptions({
                    enabled: false
                });
            }

            //기본 세팅
            voGridView.setOptions({
                linear: true,               /*컬럼 그룹을 해제하고 export 할 것인지의 여부.*/
                display: {
                    parentChangable: true  /*Drag and drop으로 이동하여 컬럼의 부모를 변경 */
                },
            });

            // 컬럼세팅
            this.setGridColumns(voGridView, poOption.columns);

            // Layout 세팅
            this.setGridLayout(voGridView, poOption.columns);
            rg2Layouts[poGridId] =  voGridView.saveColumnLayout() ;

            // 필드세팅
            this.setGridFields(voDataProvider, poOption.columns);


            /*공통버튼 */
            if((poOption.buttonFlag ?? true ) === true ){
                let rgBtns = "<button onclick='rg2Comm.exportExcel(\""+poGridId+"\") ;'>엑셀저장</button>"
                    + "<button onclick='rg2Comm.selectColumnOpen(\""+poGridId+"\") ;'>컬럼 선택</button> "
                    + "<div id='rgSelColsLayer-"+poGridId+"' class='rg-selCols-layer' style='display: none' ><div class='rg-sel-cols'></div><div class='rg-sel-btns'></div><button onclick='rg2Comm.setSelectColumn(\""+poGridId+"\") ;'>적용</button><button onclick='rg2Comm.selectColumnClose(\""+poGridId+"\") ;'>닫기</button></div>" ;
                $("#" + poGridId).before("<div id='rgbtns_" + poGridId + "' class='rg-btns'>"+rgBtns+"</span></div>");
            }

            //필터 표시영역 표시여부 default:true
            var vbFilterAreaFlag = ( poOption.filterAreaFlag ?? true) ;
            if (!vsFilterFlag || !vbFilterAreaFlag) {
                $("#" + poGridId).parents('.realgridstyle').addClass('none');
                voGridView.resetSize();  // resetSize를 해야만 크기가 조정됨.
            }

            if (vsFilterFlag) {
                var columnNames = voGridView.getColumnNames(true, false)
                for (var i = 0; i < columnNames.length; i++) {
                    voGridView.setColumnProperty(columnNames[i], "autoFilter", true);
                }
                $("#" + poGridId).after("<div id='divAutoFilter_" + poGridId + "' class='rgfilter'><span id='spanFilters_" + poGridId + "'></span></div>");

                // 하단 필터영역
                if (vbFilterAreaFlag) {
                    // 필터적용 목록
                    $("#" + poGridId).after(
                        "<span class='message'><span><img src='/images/btn_labelDel.png' style='display:none' id='" + poGridId + "_img' "
                        + " onclick='rg2Comm.filterCancel(\"" + poGridId + "\")'>"
                        + "<span id='" + poGridId + "_message' style='display:none; width: 100%'></span></span>");
                }
                // 필터변경 이벤트 등록
                voGridView.onFilteringChanged = function (grid) {
                    try {
                        var message = "";
                        var columnNames = grid.getColumnNames(true, true)
                        var filters;
                        for (var i = 0; i < columnNames.length; i++) {
                            try {
                                if (grid.isFiltered(columnNames[i])) {
                                    filters = grid.getActiveColumnFilters(columnNames[i]);
                                    if (filters.length > 0) {
                                        let column = grid.columnByName(columnNames[i]);
                                        let aHeader = grid.getColumnProperty(column, "header");
                                        message = message + ((message === "") ? "" : " and ") + "[" + aHeader.text + " = ";

                                        var filterText = "";
                                        for (var j = 0; j < filters.length; j++) {
                                            filterText = filterText + ((j > 0) ? ", " : "") + filters[j].text;
                                        }
                                        message = message + ((filterText.length > 100) ? filterText.substring(0, 100) + "..." : filterText) + "] ";
                                    }
                                }
                            } catch (e) {
                              //  console.log("isFiltered ", e);
                            }
                        }
                        if (message.length > 0) {
                            $("#" + poGridId + "_img").show();
                            $("#" + poGridId + "_message").css("color", "gray").text(" " + message).show();
                        } else {
                            $("#" + poGridId + "_img").hide();
                            $("#" + poGridId + "_message").hide();
                        }

                        //오버라이딩용 함수 호출
                        //onFilterApply(voGridView) ;
                    } catch (e) {
                    }
                }
            }

           // 사용자지정 컬럼정보 세팅
            const _scrnPgmId = voGridView.scrnPgmId  ;
            if (_scrnPgmId !== ""  && !_scrnPgmId.startsWith("comm") &&  poGridId !=="gridFile"  &&  (sessionStorage.getItem("userId") ??"") !== "" ) {
                var _menuId = voGridView.menuId    ;
                var params = {
                    gridId: poGridId,
                    scrnPgmId: _scrnPgmId,
                    menuId:_menuId
                }  ;
                try {
                    $.ajax({
                        type: "POST",
                        url:"/com/common/selectColumnPosition.do" ,
                        contentType: "application/json; charset=UTF-8",
                        dataType: "json",
                        async: true,
                        data: JSON.stringify(params),
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            return false;
                        },
                        success: function (data) {
                            if ( (data.gridColInfo??"") !== ""){
                                var _layout = JSON.parse(data.gridColInfo)   ;
                                voGridView.setColumnLayout(_layout) ;
                            }
                        }
                    });
                }catch(e1){
                    console.log(e1) ;
                }
            }
            // 컨텍스트메뉴 이벤트 등록
            if(( poOption.contextMenuFlag ?? true) ){
                this.setGridSetContextMenu(voGridView, poOption);
            }

            voGridView.displayOptions.minTableRowHeight = 21;
            voGridView.displayOptions.minRowHeight = 21;
            /*
             voGridView.displayOptions.rowHeight = 21;
             */
            rg2GridView[poGridId] = voGridView;
            rg2DataProvider[poGridId] = voDataProvider;
            rg2Columns[poGridId] = poOption.columns;
            rg2HiddenColumns[poGridId] = [] ;
            return rg2GridView[poGridId];
        } catch (e) {
            console.log(e)
        }
    },



    /**
     * grdView 컬럼정보 세팅
     *
     * @param poGridView : realGrid  Object
     * @param poColumns :  컬럼정보 Array
     * @returns gridView Object
     */
    setGridColumns: function (poGridView, poColumns) {
        try{
        let _cols = [];
        for (let i = 0; i < poColumns.length; i++) {
            var column = poColumns[i];
            if ( (column.items ?? "" ) !== ""  ) {
                for ( let j = 0 ; j < column.items.length ; j ++ ) {
                    if ( column.items[j].type === "group" ) {
                        if ( ! column.columns[ j ].name ) {
                            column.columns[ j ].name = "group_i" + i + "_j" + j;
                        }
                        for ( let k = 0 ; k < column.columns[ j ].columns.length ; k ++ ) {
                            column.columns[ j ].columns[ k ] = this.setCommonColumnsProperty( column.columns[ j ].columns[ k ] );
                            _cols.push( column.columns[ j ].columns[ k ] );
                        }
                    } else {
                        column.items[j] = this.setCommonColumnsProperty( column.items[j] );
                        _cols.push( column.items[ j ] );
                    }
                }
            //기존 group columnr
            }else if( (column.type ??"")  === "group") {

                for ( let j = 0 ; j < column.columns.length ; j ++ ) {
                    if ( column.columns[ j ].type === "group" ) {
                        if ( ! column.columns[ j ].name ) {
                            column.columns[ j ].name = "group_i" + i + "_j" + j;
                        }
                        for ( var k = 0 ; k < column.columns[ j ].columns.length ; k ++ ) {
                            column.columns[ j ].columns[ k ] = this.setCommonColumnsProperty( column.columns[ j ].columns[ k ] );
                            _cols.push( column.columns[ j ].columns[ k ] );
                        }
                    } else {
                        column.columns[ j ] = this.setCommonColumnsProperty( column.columns[ j ] );
                        _cols.push( column.columns[ j ] );
                    }
                }
            }else {
                 column = this.setCommonColumnsProperty(column);
                _cols.push(column);
            }
        }

            poGridView.setColumns(_cols);
        }catch (e) {
        }
    }
    ,

    /**
     * 입력된 컬럼정보를 이용해 필드를 구성
     *
     * @param poDataProvider  : gridView DataProvider
     * @param poColumns :  컬럼정보 Array
     */
    setGridFields: function (poDataProvider, poColumns) {
        var fieldNames = [];
        var fields = [];
        for (var i = 0; i < poColumns.length; i++) {
            var column = poColumns[i];

            if ((column.items ?? "" ) !== ""  ) {
                for ( let j = 0 ; j < column.items.length ; j ++ ) {
                    fields.push( this.setCommonFieldProperty( column.items[ j ] ) );
                    fieldNames.push( column.items[ j ].name );
                }
            }else if( (column.type ??"")  === "group") {
                for (var j = 0; j < column.columns.length; j++) {
                    if (column.columns[j].type === "group") {
                        for (var k = 0; k < column.columns[j].columns.length; k++) {
                            fields.push(this.setCommonFieldProperty(column.columns[j].columns[k]));
                            fieldNames.push(column.columns[j].columns[k].name);
                        }
                    } else if (fieldNames.indexOf(column.columns[j].name) < 0) {
                        fields.push(this.setCommonFieldProperty(column.columns[j]));
                        fieldNames.push(column.columns[j].name);
                    }
                }
            } else if (fieldNames.indexOf(column.name) < 0) {
                fields.push(this.setCommonFieldProperty(column));
                fieldNames.push(column.name);
            }
        }
        poDataProvider.setFields(fields);
    }
    ,

    /**
     *
     * grdView layout 세팅
     *
     * @param poGridView  realGrid  Object
     * @param poColumns   컬럼정보 Array
     */
    setGridLayout: function (poGridView, poColumns) {

        /**
         * 그룹 column layout
         * @param poColumn 컬럼
         * @param poOrd    순번
         * @returns {{}}
         */
        function  makeGridGroupLayout (poColumn, poOrd) {
            try{
                var _grp = {};
                _grp.name = poColumn.name || "group_i" + poOrd;
                _grp.header = poColumn.header || {};
                _grp.header.height = 30;

                if (poColumn.width) {
                    _grp.width = poColumn.width;
                }
                _grp.direction = poColumn.orientation || "horizontal"
                if (poColumn.hideChildHeaders && poColumn.hideChildHeaders === "hide") {
                    _grp.hideChildHeaders = true;
                } else {
                    _grp.hideChildHeaders = poColumn.hideChildHeaders || false;
                }
                _grp.items = [];
                if( (poColumn.items ?? "" ) !== ""){

                    for (var j = 0; j < poColumn.items.length; j++) {
                        _grp.items.push(poColumn.items[j].name);
                    }
                }
                //기존 컬럼
                if( (poColumn.columns ?? "" ) !== ""){
                    for (let j = 0; j < poColumn.columns.length; j++) {
                        if (poColumn.columns[j].type === "group") {
                            _grp.items.push( makeGridGroupLayout(poColumn.columns[j], poOrd + "" + j));

                        } else {
                            _grp.items.push(poColumn.columns[j].name);
                        }
                    }
                }
                return _grp;
            }catch (e) {
             //   console.log(e)
            }
        }
        var _layout = [];
        for (var i = 0; i < poColumns.length; i++) {
            var column = poColumns[i];
            if ((column.items ?? "" ) !== ""  ) {
                let _grp1 = makeGridGroupLayout( column , i );
                _layout.push( _grp1 );
            }else if (column.type === "group") {
                let _grp1 = makeGridGroupLayout( column , i );
                _layout.push( _grp1 );
            }else {
                _layout.push(column.name);
            }
        }
        poGridView.setColumnLayout(_layout);

    }
    ,

    /**
     * 그리도 컬럼정보 세팅 공통
     *
     * @param column
     * @returns {*}
     */
    setCommonColumnsProperty: function (column) {
        try {
            if (!column.fieldName) {
                column.fieldName = column.name;
            }
            if (!column.width) {
                column.width = "100";
            }
            var _styleName = "";
            var vsNumberFormat = "#,##0";
            if (column.editor && column.editor.type) {
                _styleName = "rg-center-align";
                if (column.editor.type === "number") {
                    if (column.styles && column.styles.numberFormat) {
                        vsNumberFormat = column.styles.numberFormat;
                        delete column.styles.numberFormat;
                    }
                    if (!column.numberFormat) {
                        vsNumberFormat = "#,##0";
                    }
                    _styleName = "rg-right-align";
                    column.numberFormat = column.numberFormat || vsNumberFormat;
                    column.editor.inputCharacters ="0-9";
                }
                //date
                if (column.editor.type === "date") {
                    var vsDatetimeFormat = "yyyy-MM-dd";
                    if (column.styles && column.styles.datetimeFormat) {
                        vsDatetimeFormat = column.styles.datetimeFormat;
                    }
                    column.datetimeFormat = column.datetimeFormat || vsDatetimeFormat
                    column.editor.commitOnSelect = true;
                    column.editor.showButtons = false   ;
                    column.editor.yearNavigation = true;
                    column.editor.datetimeFormat = column.datetimeFormat || vsDatetimeFormat
                    column.editor.startWeek = 1 ;
                }
            }
            if (column.editable === undefined) {
                column.editable = false;
            }
            //정렬
            if (column.styles && column.styles.textAlignment) {
                if(column.styles.textAlignment ==="far"){
                    _styleName  = "rg-right-align" ;
                }else if(column.styles.textAlignment ==="near"){
                    _styleName  = "rg-left-align" ;
                }else{
                    _styleName  = "rg-center-align" ;
                }
                delete column.styles.textAlignment;
            }
            if(_styleName !== "" ){
                column.styleName =  _styleName +" "+ (column.styleName||"");
            }

            //footer
            if (column.footer){
                try {
                    if( column.numberFormat  ){
                        column.footer.numberFormat = column.footer.numberFormat ||  column.numberFormat
                    }
                    //기존 groupExpression
                    if(column.footer.groupExpression ){
                        if (!(column.groupFooter)) {
                            column.groupFooter = {}  ;
                        }
                        column.groupFooter.expression = column.footer.groupExpression ;
                        delete column.footer.groupExpression;
                    }

                    if ( column.footer.styles  ) {
                        //정렬
                        if(column.footer.styles.textAlignment){
                            var _styleName1= ""  ;
                            if(column.footer.styles.textAlignment ==="far"){
                                _styleName1  = "rg-right-align" ;
                            }else if(column.footer.styles.textAlignment ==="near"){
                                _styleName1  = "rg-left-align" ;
                            }else{
                                _styleName1  = "rg-center-align" ;
                            }
                            delete column.footer.styles.textAlignment;
                            if(_styleName !== _styleName1 ){
                                _styleName = _styleName1  ;
                            }
                        }
                        //numberFormat
                        if(column.footer.styles.numberFormat && column.footer.numberFormat ){
                            if(column.footer.styles.numberFormat !==  (column.footer.numberFormat ?? "") ){
                                column.footer.numberFormat = column.footer.styles.numberFormat  ;
                            }
                            delete column.footer.styles.numberFormat;
                        }
                        delete column.footer.styles ;
                    }
                    if(_styleName !== "" ){
                        column.footer.styleName =  _styleName +" "+ (column.footer.styleName||"");
                    }
                }catch(e) {
                }
            }
           //groupFooter
            if (column.groupFooter) {
                if( column.numberFormat  ){
                    column.groupFooter.numberFormat = column.groupFooter.numberFormat ||  column.numberFormat
                }
                if( column.styleName  ){
                    column.groupFooter.styleName = column.groupFooter.styleName ||  column.styleName
                }
            }

            if (column.displayRegExp && column.displayReplace) {
                var _exp = (column.displayRegExp + "").replace(/\//gi, "").replace(/\^/gi, "");
                column.textFormat = _exp + ";" + column.displayReplace;
                delete column.displayRegExp;
                delete column.displayReplace;
            }

            //dropdown : valaues, labels  복사
            if (column.lookupDisplay && column.editor && column.editor.type.toLowerCase() === "dropdown") {
                column.editor.type = "dropdown";
                if (column.values) {
                    column.editor.values = column.values;
                }
                if (column.labels) {
                    column.editor.labels = column.labels;
                }
            }
            //소재 보기
            if (column.name === "mtrlView") {
                column.header = {
                    "text": "소재보기"
                };
                column.renderer = {
                    type: "icon"
                    , "textVisible": false
                    , iconLocation: "center"
                    , iconMap: {
                          "0": '/images/btn_play.png'
                        , "IMG": '/images/ico_shp01.png'
                        , "IMG1": '/images/ico_search2.png'
                    }
                };
            }
            if (column.name === "searchView" || column.name === "searchViewCli") {
                column.header = {
                    "text": ""
                };
                column.renderer = {
                    type: "icon"
                    , "textVisible": false
                    , iconLocation: "center"
                    , iconMap: {
                        "IMG1": '/images/ico_search2.png'
                        , "IMG2": '/images/ico_search2.png'
                    }
                };
            }

            //케이블 미리보기
            if (column.name.indexOf("PREVIEW") >= 0) {
                column.header = {
                    "text": "소재보기"
                };
                column.renderer = {
                    type: "html",
                    callback: function (grid, cell, w, h) {
                        try {
                            let _media_id = ''
                            if (column.name === "BFCHG_MEDIA_PREVIEW") {
                                _media_id = grid.getValue(cell.index._itemIndex, "BFCHG_MEDIA_ID");
                            } else if (column.name === "AFTCHG_MEDIA_PREVIEW") {
                                _media_id = grid.getValue(cell.index._itemIndex, "AFTCHG_MEDIA_ID");
                            } else {
                                _media_id = grid.getValue(cell.index._itemIndex, "MEDIA_ID");
                            }
                            var str = "";

                            if (_media_id !== '') {
                                str = "<img src='/images/btn_play.png'  onClick=gfn_previewPopup('" + _media_id + "');  >";
                            }
                            return str;
                        } catch (e) {

                        }
                    }
                }
            }
            //ToolTip 표시
            if( ( column.editor ?? "") === ""  ||  ( column.editor.type ?? "") === "" ){
                if(Number(column.width) >= 120  && (column.textFormat ?? "") === ""  ){
                    if(column.name.indexOf("Dt") <  0 ){
                        column.renderer = { showTooltip: true}
                    }
                }
            }
            return column;
        } catch (e1) {

        }
    },


    /**
     * 그리도 필드 정보 세팅 공통
     * @param column
     * @returns {{}}
     */
    setCommonFieldProperty: function (column) {
        var field = {};
        field.fieldName = column.name;
        if (column.editor && column.editor.type) {
            if ( column.editor.type.toLowerCase() !== "dropdown") {
                if (column.editor.type === "date") {
                    field.dataType = column.editor.type;
                    field.datetimeFormat = "yyyyMMdd";
                } else {
                    field.dataType = column.editor.type;
                }
            }
        }
        //계산필드드
        if (column.calculateExpression || column.valueExpression) {
            field.valueExpression = column.calculateExpression || column.valueExpression;
            field.dataType = "number";
        }
        if (column.calculateCallback) {
            /*
            dataField.valueCallback = function (provider, dataRow, fieldName, fieldNames, values) {
            , "calculateCallback": function (dataRow, fieldName, fieldNames, values) {
            field.calculateCallback = function {}
     */

            field.calculateCallback = column.calculateCallback;
        }
        if (column.valueCallback) {
            field.valueCallback = column.valueCallback;
        }
        return field;
    },


    /**
     *
     * @param poGridView
     * @param poOption
     */
    setGridSetContextMenu: function (poGridView, poOption) {
        // 컨택스트 메뉴 등록
        let vaContextMenu = [];
        if (poGridView.getGroupingOptions().enabled) {
            vaContextMenu.push({
                label: "Grouping",
                children: [
                    {
                        label: "전체그룹펼치기"
                        , tag: "expandGroup"
                    }
                    , {
                        label: "전체그룹접기"
                        , tag: "collapseGroup"
                    }
                    , {label: "-"}
                    , {
                        label: "선택 칼럼 Grouping"
                        , tag: "groupBy"
                    }
                    , {
                        label: "선택 칼럼 Grouping 취소"
                        , tag: "groupByCancel"
                    }
                    , {label: "-"}
                    , {
                        label: "전체 Grouping 취소"
                        , tag: "groupByCancelAll"
                    }]
            });
            vaContextMenu.push({label: "-"});
        }
        vaContextMenu.push({
            label: "칼럼설정",
            children: [
                {
                    label: '칼럼 열 고정'
                    , tag: 'fixedCol'
                }
                , {
                    label: '칼럼 행 고정'
                    , tag: 'fixedRow'
                }
                , {
                    label: '칼럼 틀고정 취소'
                    , tag: 'fixedCancel'
                }
                , {
                    label: "-"
                }
                , {
                    label: '칼럼 숨기기'
                    , tag: 'visibleFalse'
                }
                , {
                    label: "칼럼 숨기기 취소"
                    , tag: 'visibleTrue',
                }
                , {
                    label: "-"
                }, {
                    label: "칼럼 크기 자동맞추기"
                    , tag: 'autoFit'
                }, {
                    label: "전체 칼럼 크기 자동맞추기"
                    , tag: 'autoFitAll'
                }]
        });

        //공통 팝업일 경우 컬럼 설정 제외(
            var _scrnPgmId = poGridView.scrnPgmId   ;
            if(_scrnPgmId !=="" &&  !_scrnPgmId.startsWith("comm")){
                vaContextMenu.push({label: "-"});
                if (!(poOption.saveColumnFlag === false)) {
                    vaContextMenu.push({
                        label: "그리드설정",
                        children: [{
                            label: "그리드 설정 초기화"
                            , tag: 'optionReset'
                        }, {
                            label: "그리드 칼럼 위치 저장"
                            , tag: 'columnSave'
                        }]
                    });
                vaContextMenu.push({label: "-"});
            }
        }

        vaContextMenu.push({
            label: "엑셀저장"
            , tag: 'excel'
        });

        try{
            poGridView.setContextMenu(vaContextMenu);

            /*컨텐스트 메뉴 이벤트  */
            poGridView.onContextMenuItemClicked = function (grid, item, clickData) {
                var _tag = item.tag;
                var _gridId = grid.getContainer().id ;
                let names;
                let count;
                switch (_tag) {
                    case "expandGroup" :   /*전체그룹펼치기*/
                        grid.expandAll();
                        break;
                    case "collapseGroup" :   /*전체그룹접기 */
                        grid.collapseAll();
                        break;
                    case "groupBy" :   /* 선택 칼럼 Grouping  */
                        names = grid.getGroupFieldNames();
                        if (names === null) {
                            grid.groupBy([clickData.fieldName]);
                        } else {
                            names[names.length] = clickData.fieldName;
                            grid.groupBy(names)
                        }
                        break;
                    case "groupByCancel" :   /* 선택 칼럼 Grouping  취소 */
                        names = grid.getGroupFieldNames();
                        var _idx = names.indexOf(clickData.fieldName)   ;
                        if(_idx >= 0 ){
                            names.splice(_idx, 1)
                        }
                        grid.groupBy(names);
                        break;
                    case "groupByCancelAll" :   /* 전체 Grouping 취소 */
                        grid.groupBy([]);
                        break;
                    case "fixedCol" :   /* 칼럼 열 고정 */
                        count = grid.getColumnProperty(clickData.column, "displayIndex") + 1;
                        grid.setFixedOptions({colCount: count});
                        break;
                    case "fixedRow" :   /* 칼럼 행 고정 */
                        count = clickData.itemIndex + 1;
                        grid.setFixedOptions({rowCount: count});
                        break;
                    case "fixedCancel" :   /* 칼럼 틀고정 취소 */
                        grid.setFixedOptions({colCount: 0, rowCount: 0});
                        break;
                    case "visibleFalse" :   /* 컬럼 숨기기 */
                        grid.setColumnVisible(clickData.column,   false);
                        break;
                    case "visibleTrue" :   /* 칼럼 숨기기 취소  */
                         grid.setColumnVisible([], true);
                        break;
                    case "autoFit" :   /* 칼럼 크기 자동맞추기 */
                        grid.fitLayoutWidth(clickData.column)
                        break;
                    case "autoFitAll" :   /* 전체 칼럼 크기 자동맞추기  */
                        grid.fitLayoutWidth(null);
                        break;



                    case "optionReset" :   /* 그리드 설정 초기화  */
                        try{
                            // 사용자지정 컬럼정보 세팅
                            if( (grid.scrnPgmId  ??"")   !== "" &&  ( grid.menuId  ?? "")  !== ""){
                                var params = {
                                    gridId: _gridId  ,
                                    scrnPgmId: grid.scrnPgmId ,
                                    menuId:  grid.menuId
                                }  ;
                                $.ajax({
                                    type: "POST",
                                    url: "/com/common/deleteGridColumnPosition.do" ,
                                    contentType: "application/json; charset=UTF-8",
                                    dataType: "json",
                                    async: true,
                                    data: JSON.stringify(params),
                                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                                        return false;
                                    },
                                    success: function (data) {
                                    }
                                });
                            }
                        }catch (e) {
                        }
                        grid.setColumnLayout(rg2Layouts[_gridId]) ;

                        break;
                    case "columnSave" :   /* 그리드 컬럼 위치 저장  */
                        rg2Comm.columnSave(_gridId) ;
                        break;
                    case "excel" :   /* 엑셀저장  */
                        rg2Comm.exportExcel( grid.id) ;
                        break;
                    default :
                        break;
                }
            }

        }catch (e2) {
        }
    },



    /**
     * 그리드 데이터 상태에 따른 데이터 json 을 Array  반환
     * @param poGridId : gridView
     * @param psRowState : 그리드 상태 옵션 ('A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신, default:'M')
     * @param psRtnMsgYn : 메시지표시 여부 ( N: 표시안함, default : Y)
     *
     * @returns {boolean|*}
     */

    getRowStatesValues: function (poGridId, psRowState, psRtnMsgYn) {
        var gridView = this.getGridView(poGridId);
        gridView.commit();
        var dataProvider = gridView.getDataSource();

        var _statusIndex = [];
        var  jsonArray  = [] ;

        // status에 따른 데이터
        if (psRowState === "A") {
            _statusIndex = dataProvider.getAllStateRows();
            _statusIndex["none"] = dataProvider.getStateRows();
        } else if (psRowState === "M") {
            _statusIndex = dataProvider.getAllStateRows();
        } else {
            _statusIndex[rg2RowState[psRowState]] = dataProvider.getStateRows(rg2RowState[psRowState]);
        }
        for (let _status  in rg2RowState.properties) {
            if(  _statusIndex[_status] !== undefined){
                _statusIndex[_status].forEach(function (dataRow, _index) {
                    var vaJson = dataProvider.getOutputRow(rg2RowGetOpt, dataRow);
                    vaJson.dataRow = dataRow ;
                    vaJson.itemIndex = gridView.getItemIndex(dataRow) ;
                    vaJson.RowState = rg2RowState.properties[_status].name  ;
                    jsonArray.push(vaJson);
                })
            }
        }
        if(jsonArray.length <= 0  ){
            if(psRtnMsgYn !== "N"){
                MsgBox.show(rg2RowState.properties[rg2RowState[psRowState]].msg  + " 데이터가 없습니다.");
            }
            return false;
        }else{
            return jsonArray;
        }

    }
    ,

    /**
     * 그리드 체크된 데이터  json 을 Array  반환
     * @param poGridId : gridView
     * @param psRtnMsgYn : 메시지표시 여부 ( N: 표시안함, default : Y)
     * @returns {boolean|*}
     */
    getCheckedValues: function (poGridId, psRtnMsgYn ) {
        var gridView = null;
        gridView = this.getGridView(poGridId);
        gridView.commit();

        var _rows = gridView.getCheckedRows();
        if (_rows.length <= 0 ) {
            if(psRtnMsgYn !== "N") {
                MsgBox.show("선택된 데이터가 없습니다.");
            }
            return false;
        } else {
            var dataProvider  = gridView.getDataSource() ;
            let jsonArray = [];
            _rows.forEach(function (dataRow, _index) {
                var vaJson = dataProvider.getOutputRow(rg2RowGetOpt, dataRow);
                vaJson.dataRow = dataRow ;
                vaJson.itemIndex = gridView.getItemIndex(dataRow) ;
                vaJson.RowState = rg2RowState.properties[dataProvider.getRowState(dataRow)].name  ;
                jsonArray.push(vaJson);
            })
            return jsonArray;
        }
    }
    ,

    /**
     * stRowIndex 부처  lastRowIndex  까지의 범위에서  colIndex의 값이 dataValue와 같은 행들을 찾아서 targetCol에 해당하는 열의 값들을 배열로 반환합니다.
     *
     * @param poGridId : 그리드 아이디
     * @param colIndex : 찾을 컬럼
     * @param dataValue : 찾을 값
     * @param targetCol  : 데이터를 가져올 컬럼
     * @param exactMatch : 정확히 일치하는지 여부(필수X, default :true)
     * @param stRowIndex : 데이터를 가져오는 것을 시작할 행 번호(필수X, default : 0 )
     * @param lastRowIndex : 데이터를 가져오는 것을 끝낼 행 번호(필수X, default :grid.getItemCount())
     * @returns Array
     */
    getMatchedColumnValues: function (poGrid, colIndex, dataValue, targetCol, exactMatch, stRowIndex, lastRowIndex) {
        rg2Comm.gridCommit();
        var gridView =  rg2Comm.getGridView(poGrid);
        var rtnValue = [];

        stRowIndex = stRowIndex ||0 ;
        lastRowIndex = lastRowIndex ||gridView.getItemCount() ;

        //부분일치여부
        var vbPartialMatch = false;
        if(!exactMatch){
            vbPartialMatch = true;
        }
        while(stRowIndex < lastRowIndex){
            var options = {
                fields: [colIndex],
                values: [dataValue],
                startIndex: stRowIndex,
                caseSensitive: true,
                partialMatch: vbPartialMatch,
                wrap: false,
                select: false
            };

            var _itemIndex = gridView.searchItem(options);
            //일치된값이 없으면 주지
            if(_itemIndex === -1){
                break;
            }
            var value = gridView.getValue(_itemIndex,  targetCol);
            rtnValue.push(value);

            stRowIndex = _itemIndex + 1;
        }

        //일치된 행번호의 타겟컬럼의 값을 배열로 반환
        return rtnValue;
    },


    /**
     * stRowIndex 부처  lastRowIndex  까지의 범위에서 colIndex의 값이 dataValue와 같은 행들을 찾아서 전체 데이터를 반환
     *
     * @param poGridId : 그리드 아이디
     * @param colIndex : 찾을 컬럼
     * @param dataValue : 찾을 값
     * @param targetCol  : 데이터를 가져올 컬럼
     * @param exactMatch : 정확히 일치하는지 여부(필수X, default :true)
     * @param stRowIndex : 데이터를 가져오는 것을 시작할 행 번호(필수X, default : 0 )
     * @param lastRowIndex : 데이터를 가져오는 것을 끝낼 행 번호(필수X, default :grid.getItemCount())
     * @returns Array
     */
    getMatchedValues: function (poGrid, colIndex, dataValue,  exactMatch, stRowIndex, lastRowIndex) {
        rg2Comm.gridCommit();
        var gridView =  rg2Comm.getGridView(poGrid);
        var dataProvider = gridView.getDataSource() ;
        var rtnValue = [];

        stRowIndex = stRowIndex ||0 ;
        lastRowIndex = lastRowIndex ||gridView.getItemCount() ;

        //부분일치여부
        var vbPartialMatch = false;
        if(!exactMatch){
            vbPartialMatch = true;
        }
        while(stRowIndex < lastRowIndex){
            var options = {
                fields: [colIndex],
                values: [dataValue],
                startIndex: stRowIndex,
                caseSensitive: true,
                partialMatch: vbPartialMatch,
                wrap: false,
                select: false
            };
            var _itemIndex = gridView.searchItem(options);
            //일치된값이 없으면 주지
            if(_itemIndex === -1){
                break;
            }
            var _values = gridView.getValues(_itemIndex );
            _values.itemIndex =_itemIndex ;
            _values.dataRow = gridView.getDataRow(_itemIndex)  ;
            _values.RowState = rg2RowState.properties[dataProvider.getRowState(_values.dataRow)].name  ;
             rtnValue.push(_values);

            stRowIndex = _itemIndex + 1;
        }

        //일치된 행번호의 타겟컬럼의 값을 배열로 반환
        return rtnValue;
    },

    /**
     * 그리드에 적용된 필터를 해제한다.
     *
     * @param poGridId : 그리드 아이디
     */
    filterCancel :function (psGridId) {
        rg2Comm.gridCommit();
        var gridView =  rg2Comm.getGridView(psGridId);

        (gridView.getColumnNames(false)).forEach(function (_columnName, _index) {
            gridView.activateAllColumnFilters(_columnName, false);
        })
        $("#" + psGridId + "_img").hide();
        $("#" + psGridId + "_message").text("")  ;
    },

    /**
     * 그리드 값의 null 여부를 체크하고 해당 cell 포 포커스
     *
     *
     * @param psGridId  gridView
     * @param psCols  : 검증할 컬럼 배열
     * @param psChecked  : 체크 row 여부
     * @param psRowState : 그리드 상태 옵션 ('A':그리드 모든 데이터 'M':갱신,삽입,삭제 'C':삽입 'D':삭제 'U':갱신, default:'M')
     * @returns {boolean}
     *
     *
     * @example
     * rg2Comm.checkValidateNotNull(grid2, ["pgmMdlKndCd", "pgmMdlKndNm"], true )
     * rg2Comm.checkValidateNotNull(grid2, ["pgmMdlKndCd", "pgmMdlKndNm"], false, "M" )    *
     *
     */
    checkValidateNotNull : function (psGridId, psCols , psChecked, psRowState) {
        var _gridJson = null ;
        //check 컬럼 없을 경우
        if(psCols === undefined || psCols === null || psCols.length <=0 ){
            return false ;
        }

        rg2Comm.gridCommit() ;
        if(psChecked){
            _gridJson = rg2Comm.getCheckedValues(psGridId )
        }else{
            _gridJson = rg2Comm.getRowStatesValues(psGridId, psRowState)   ;
        }
        if(_gridJson === null  || !_gridJson  || _gridJson.length <= 0 ){
            return false  ;
        }
        var gridView = this.getGridView(psGridId);
        var _ret = true ;
        _gridJson.forEach(function (_vals, _index) {
            if(_ret){
                psCols.forEach(function (_col, _idx) {
                    if(_ret) {
                        if ( (_vals[_col] ?? "") === "") {
                            MSG.show(MESSAGE.ERR.M002, [gridView.columnByName(_col).header.text]);
                            gridView.setFocus(_vals.itemIndex, _col);
                            _ret = false;
                            return false;
                        }
                    }
                });
            }
        }) ;

        return _ret ;
    } ,


    /**
     * 그리드 dropDown item 설정
     *
     * @param psGridId  gridView
     * @param psCols   dropDown 컬럼
     * @param psDataList JsonArray  데이터
     * @param psValue  DropDown 컬럼의 value 에 들어갈 psDataList 의 key  ( 생략할 경우 commCd )
     * @param psLabel  DropDown 컬럼의 label 에 들어갈 psDataList 의 key  (생략할 경우 commCdNm )
     *
     * @example
     * rg2Comm.setDropDownList(grid1, "athrCd", voJson.listMain )  ;
     * rg2Comm.setDropDownList(grid1, "athrCd", voJson.listMain , commCd, commCdNm  )  ;
     */
    setDropDownList : function (psGridId, psCols , psDataList, psValue, psLabel ) {
        var _values = [];
        var _labels = [];

        var gridView = this.getGridView(psGridId);
        var _column = gridView.columnByName(psCols);

        if((psValue ?? "" ) === "" ){
            psValue = "commCd" ;
        }
        if( (psLabel ?? "" ) === "" ){
            psLabel = "commCdNm" ;
        }

        if(_column !== null ){
            $.each(psDataList, function(k, v) {
                _values.push(v[psValue]);
                _labels.push(v[psLabel]);
            });
            _column.values = _values;
            _column.labels = _labels;

            _column.editor.values = _values;
            _column.editor.labels = _labels;
        }
    },


    /**
     * 그리드 체크된 Row 컬럼의 합
     * @param poGridId : gridView
     * @param fieldName :컬럼명
     * @param commitYn :commit 여부
     * @returns {boolean|*}
     */
    getCheckedSum: function (poGridId, fieldName , commitYn = false ) {
        var gridView = null;
        gridView = this.getGridView(poGridId);
        if(commitYn){
            gridView.commit();
        }
        var sum = 0 ;
        var _rows = gridView.getCheckedRows();
        if (_rows.length >  0 ) {
            var dataProvider  = gridView.getDataSource() ;
            _rows.forEach(function (dataRow, _index) {
                sum += Number(dataProvider.getValue(dataRow, fieldName ));
            })
        }
        return sum ;
    }
    ,
    /**
     * 그리드 엑셀저장
     * @param poGridId : gridView
     */
    exportExcel:function (poGridId){
        var gridView = null;
        gridView = this.getGridView(poGridId);
        var vsFileName = $("#" + gridView.id).attr("title");
        if ((vsFileName ?? "")  === "" ) {
            vsFileName =  ($("#contentsHeaderTitle").text()  ||  document.title ) ;
        }
        gridView.exportGrid({
            type: "excel",
            target: "local",
            fileName: vsFileName + ".xlsx",
            showProgress: true,
            progressMessage: "엑셀 Export중입니다.",
            lookupDisplay: true,
            compatibility: true,
            applyDynamicStyles: true,
            allItems: true
        });
    } ,

    /**
     * 그리드 위치 저장
     * @param poGridId : gridView
     */
    columnSave :function (poGridId){
        var gridView = null;
        gridView = this.getGridView(poGridId);
        try{
            // 사용자지정 컬럼정보 세팅
            if( (gridView.scrnPgmId  ??"")   !== "" ||  ( gridView.menuId  ?? "")  !== "") {
                let params = {
                    gridId : poGridId ,
                    scrnPgmId : gridView.scrnPgmId ,
                    menuId : gridView.menuId ,
                    gridColInfo : JSON.stringify( gridView.saveColumnLayout() )
                };
                $.ajax( {
                    type : "POST" ,
                    url : "/com/common/createGridColumnPosition.do" ,
                    contentType : "application/json; charset=UTF-8" ,
                    dataType : "json" ,
                    async : true ,
                    data : JSON.stringify( params ) ,
                    error : function ( XMLHttpRequest , textStatus , errorThrown ) {
                        return false;
                    } ,
                    success : function ( data ) {
                    }
                } );
            }
        }catch (e) {
            console.log(e)
        }

    },
    /**
     * 그리드 컬럼 선택 레이어 오픈
     * @param poGridId : gridView
     */
    selectColumnOpen :  function(poGridId){
        var gridView = null;
        gridView = this.getGridView(poGridId);
        $("#rgSelColsLayer-"+poGridId +" .rg-sel-cols").empty()   ;
        let str = ""  ;

        //설정된 컬럼
        let _col = rg2Columns[poGridId]   ;
        //Layout  저장
        let _cols =  gridView.saveColumnLayout()    ;
        _col.forEach(function(item, indx){
            if(( item.visible ?? true) ){
                str +="<label><input type='checkbox' id ='gridC"+indx+"' value='"+item.name+"'  ";
                if( _cols.some((item2)=> item.name === item2.column && item2.visible )) str +=" checked " ;
                str +="/> "+item.header.text+"</label><br/>"   ;
            }
        }) ;

        $("#rgSelColsLayer-"+poGridId +" .rg-sel-cols").append(str)   ;
        $("#rgSelColsLayer-"+poGridId).show()   ;
    } ,
    /**
     * 그리드 컬럼 선택 적용
     * @param poGridId : gridView
     */
    setSelectColumn :function (poGridId){
        try{
            var gridView = null;
            gridView = this.getGridView(poGridId);

            let _cols = $("#rgSelColsLayer-"+poGridId +" .rg-sel-cols").find('input')  ;
            _cols.each(function ( indx, item  ){
                gridView.setColumnVisible(item.value , item.checked )  ;
            })
            rg2Comm.columnSave(poGridId) ;
            $("#rgSelColsLayer-"+poGridId).hide()   ;
        }catch (e) {
            console.log(e)
        }
    },
    /**
     * 그리드 컬럼 선택 닫기
     * @param poGridId : gridView
     */
    selectColumnClose  :function (poGridId){
        $("#rgSelColsLayer-"+poGridId).hide()   ;
    }
}


window.rg2Comm  =  rg2Comm  ;
//rg2ommon END  ------------------------------------------------------------------------------

$(document).click(function (e) {
});
